import React, { useContext, useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { AuthContext } from "../auth/AuthContext";
import { sendLoginOtp, verifyLoginOtp , createBookingApi, createPrePaidOrderApi, checkOutPrePaidBooking } from "../auth/authApi";
import {clearCart} from "../../redux/cart/cartSlice"
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import LoadingForm from "../others/LoadingForm";



function CheckBookingForm({ onBack, onClose }) {


  const dispatch = useDispatch();
  const navigate = useNavigate();


  const { isAuth, login, user } = useContext(AuthContext);
  const cartItems = useSelector((state) => state.cart.items);

  const subtotal = cartItems.reduce(
    (sum, item) => sum + item.price * item.qty,
    0,
  );

  const totalPaybleAmmountOnline = () =>
    subtotal > 450 ? subtotal - 50 : subtotal;

  const totalItems = cartItems.reduce((total, item) => total + item.qty, 0);

  // useEffect(() => {
  //   totalPaybleAmmountOnline();
  // }, [subtotal]);



const [showOrderSummary, setShowOrderSummary] = useState(false);

  
  /* ================= lOGIN OTP STATES ================= */
  const [mobile, setMobile] = useState("");
  const [otp, setOtp] = useState("");
  const [otpSent, setOtpSent] = useState(false);
  const [errorSMS, setErrorSMS] = useState(null);
  const [loading, setLoading] = useState(false);
const [bookingLoader, setBookingLoader] = useState(false);



const [otpRequested, setOtpRequested] = useState(false);
const [otpVerified, setOtpVerified] = useState(false);


  /* ================= ADDRESS STATES ================= */

  const [pincode, setPincode] = useState("");
  const [city, setCity] = useState("");
  const [stateName, setStateName] = useState("");
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [address1, setAddress1] = useState("");
  const [address2, setAddress2] = useState("");
  const [addressType, setAddressType] = useState("Home");

  const [pinError, setPinError] = useState("");
  const [pinLoading, setPinLoading] = useState(false);

  const [formError, setFormError] = useState("");


  const handlePincode = async (value) => {
    const pin = value.replace(/\D/g, "");
    setPincode(pin);
    setCity("");
    setStateName("");
    setPinError("");

    if (pin.length < 6) return;

    try {
      setPinLoading(true);
      const res = await fetch(`https://api.postalpincode.in/pincode/${pin}`);
      const data = await res.json();

      if (data[0].Status === "Success") {
        const po = data[0].PostOffice[0];
        setCity(po.District);
        setStateName(po.State);
      } else {
        setPinError("Invalid pincode");
      }
    } catch {
      setPinError("Unable to fetch pincode details");
    } finally {
      setPinLoading(false);
    }
  };



  // APP lOGIN INSIDE CHECK OUT ::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::
  // :::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::

const handleSendOtp = async () => {
  try {
    setLoading(true);
    const res = await sendLoginOtp(mobile);
    

    if (res.data.success) {
      setOtpSent(true);
      setOtpRequested(true); 
      setErrorSMS(null);
    }
  } catch (err) {
    setErrorSMS(err.response?.data?.message || "Failed to send OTP");
  } finally {
    setLoading(false);
  }
};







const handleVerifyOtp = async () => {
  try {
    setLoading(true);
    const res = await verifyLoginOtp(mobile, otp);

    if (!res.data?.accessToken) {
      setErrorSMS("Login failed");
      return;
    }

    //  LOGIN:::::::::::::::::::::::::::::::::::::::::::::::::::::
    login(res.data.accessToken, res.data.user);
    setOtpVerified(true);

    // cleanup
    setOtp("");
    setOtpSent(false);
    setOtpRequested(false);
    setErrorSMS(null);

  } catch (err) {
    setErrorSMS(err.response?.data?.message || "OTP verification failed");
  } finally {
    setLoading(false);
  }
};





useEffect(() => {
  if (
    mobile.length === 10 &&
    !otpRequested &&
    !loading

  ) {
    handleSendOtp();
    // console.log("Otp api called");
  }



}, [mobile]);


useEffect(() => {
  if (
    otp.length === 6 &&
    otpSent &&
    !otpVerified &&
    !loading
  ) {
    handleVerifyOtp();
    // console.log("requested api called")
  }
}, [otp]);





      // AUTH CONTEXT UPDATE:::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::
      // ::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::






      // BOOKING FEATUES START HERE :::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::
      // ::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::


 const handleChange = (setter) => (e) => {
  setter(e.target.value);
  if (formError) setFormError(""); 
};


const validateBookingPayload = (payload) => {

  if (!payload.items || payload.items.length === 0) {
    return "Cart is empty";
  }


  for (const item of payload.items) {
    if (!item.productId || !item.name || !item.price || !item.qty) {
      return "Invalid product in cart";
    }
  }

  const a = payload.shippingAddress;
  if (
    !a.firstName ||
    !a.lastName ||
    !a.address1 ||
    !a.city ||
    !a.state ||
    !a.pincode
  ) {
    return "Please complete shipping address";
  }

  if (a.pincode.length !== 6) {
    return "Invalid pincode";
  }

  if (
    !payload.price ||
    payload.price.totalPayable <= 0
  ) {
    return "Invalid price";
  }

  if (!["CASH", "ONLINE"].includes(payload.paymentMethod)) {
    return "Invalid payment method";
  }

  return null;
};



const buildBookingPayload = (paymentMethod) => {
  return {
    items: cartItems.map((item) => ({
      productId: item._id,
      name: item.name,
      price: item.price,
      qty: item.qty,
      varient:item.note,
    })),

    totalItems,

    shippingAddress: {
      firstName,
      lastName,
      address1,
      address2,
      city,
      state: stateName,
      pincode,
      addressType,
    },

    price: {
      subtotal,
      totalPayable:
        paymentMethod === "ONLINE"
          ? totalPaybleAmmountOnline()
          : subtotal,
    },

    paymentMethod, 
  };
};






const handleCashBooking = async () => {
  try {
    setBookingLoader(true);
    const payload = buildBookingPayload("CASH");
    const error = validateBookingPayload(payload);
    if (error) {
      setFormError(error);
      return;
    }
 
    const res = await createBookingApi(payload);
    if(res.success){
      dispatch(clearCart()); 
      onClose();
      navigate("/thanks-booking",{
        state:{
          bookingRes:res
        }
      });
   
    }

    // console.log(res);

  } catch (err) {

   setFormError(err?.response?.data?.message || "Booking failed");

    // console.log(err.response?.data)
  } finally {
    setBookingLoader(false);
    
  }
};




// Start payment gateway services features:::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::
// ::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::



const loadRazorpay = () => {
  return new Promise((resolve) => {
    const script = document.createElement("script");
    script.src = "https://checkout.razorpay.com/v1/checkout.js";
    script.onload = () => resolve(true);
    script.onerror = () => resolve(false);
    document.body.appendChild(script);
  });
};



// const handleOnlineBooking = async () => {

//   try {
//     setBookingLoader(true);

//     const payload = buildBookingPayload("ONLINE");
//     const error = validateBookingPayload(payload);
//     if (error) {
//       setFormError(error);
//       return;
//     }

 
//     const orderRes = await createPrePaidOrderApi({
//       amount:payload.price.totalPayable,
//     });
//     const { orderId, amount, key } = orderRes.data;


//     const loaded = await loadRazorpay();
//     if (!loaded) {
//       alert("Try again")
//       return;
//     }

//     const options = {
//       key,                
//       amount,            
//       currency: "INR",
//       order_id: orderId,

//       name: "Kuina",
//       description: "Order Payment",

//       prefill: {
//         contact: user.mobileNumber,
//       },

//        method: {
//     upi: true,
//     card: true,
//     netbanking: true,
//     wallet: false,
//     paylater: false,
//     emi: false,
//   },


//       handler: async function (response) {
//         // response = { razorpay_order_id, razorpay_payment_id, razorpay_signature }

//         const verifyRes = await checkOutPrePaidBooking({
//           ...response,
//           bookingData: payload,
//         });

//         if (verifyRes?.data?.success) {
//           dispatch(clearCart());
//           onClose();

//         navigate("/thanks-booking",{
//         state:{
//           bookingRes:verifyRes.data
//         }
//       });


//        setBookingLoader(false);

//         }
//       },

//       theme: { color: "#dd1d4d" },
//     };

//     const rzp = new window.Razorpay(options);
//     rzp.open();
//   } catch (err) {
//     // console.log(err);




//     alert(err?.response?.data?.message || "Payment failed");
//   }
// };




const handleOnlineBooking = async () => {
  try {
    setBookingLoader(true);

    const payload = buildBookingPayload("ONLINE");
    const error = validateBookingPayload(payload);
    if (error) {
      setFormError(error);
      setBookingLoader(false);
      return;
    }

    const orderRes = await createPrePaidOrderApi({
      amount: payload.price.totalPayable,
    });

    const { orderId, amount, key } = orderRes.data;

    const loaded = await loadRazorpay();
    if (!loaded) {
      alert("Razorpay failed to load");
      setBookingLoader(false);
      return;
    }

    const options = {
      key,
      amount,
      currency: "INR",
      order_id: orderId,

      name: "Kuina",
      description: "Order Payment",

      prefill: {
        contact: user.mobileNumber,
      },

      method: {
        upi: true,
        card: true,
        netbanking: true,
        wallet: false,
        paylater: false,
        emi: false,
      },

      // PAYMENT SUCCESS::::::::::::::::::::::::::::::::::::::::::::::
      handler: async function (response) {
        try {
          const verifyRes = await checkOutPrePaidBooking({
            ...response,
            bookingData: payload,
          });

          if (verifyRes?.data?.success) {
            dispatch(clearCart());
            onClose();

            navigate("/thanks-booking", {
              replace: true,              
              state: { bookingRes: verifyRes.data },
            });
          }
        } finally {
          setBookingLoader(false);
        }
      },

      // USER CLOSES PAYMENT MODAL::::::::::::::::::::::::::::::::::::::::::
      modal: {
        ondismiss: function () {
          // console.log("Payment popup closed by user");
          setBookingLoader(false);       
        },
      },

      theme: { color: "#dd1d4d" },
    };

    const rzp = new window.Razorpay(options);

    // PAYMENT FAILED EVENT::::::::::::::::::::::::::::::::::::::::::::::::::::::
    rzp.on("payment.failed", function (response) {
      // console.log("Payment failed", response);
      alert("Payment failed or cancelled");
      setBookingLoader(false);          
    });

    rzp.open();
  } catch (err) {
    setBookingLoader(false);
    alert(err?.response?.data?.message || "Payment failed");
  }
};



if (bookingLoader) {
  return  <LoadingForm/>
}

  return (


    <div className="check-booking-form-bg" onClick={onClose}>
      <div
        className="check-booking-form-container"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="check-booking-content">
          <div className="check-booking-top-header-row">
            <i className="fa-solid fa-arrow-left" onClick={onBack}></i>
            <div className="check-booking-top-header-icon-img">icon</div>
            <i className="fa-solid fa-xmark" onClick={onClose}></i>
          </div>

          <div className="check--booking-offer-sm-heading">
            ₹50 OFF on Prepaid orders above ₹450
          </div>

          <div className="check-booking-order-summary">

              <div
                className="check-booking-order-summay"
                onClick={() => setShowOrderSummary(true)}
              >
                <span>Order summary ({totalItems} items)</span>
                <span>
                  ₹{subtotal} <i className="fa-solid fa-chevron-up"></i>
                </span>
              </div>


          </div>





{showOrderSummary && (
  <div
    className="order-summary-overlay"
    onClick={() => setShowOrderSummary(false)}
  >
    <div
      className="order-summary-sheet"
      onClick={(e) => e.stopPropagation()} 
    >
     
      <div className="order-summary-header">
        <h4>Order Summary</h4>
        <span
          className="close-btn"
          onClick={() => setShowOrderSummary(false)}
        >
          ✕
        </span>
      </div>

    
      <div className="order-summary-items">
        {cartItems.map((item) => (
          <div className="order-summary-item" key={item.id}>
            <div>
              <p className="item-name">{item.name}</p>
              <p className="item-qty">Qty: {item.qty}</p>
            </div>
            <p className="item-price">
              ₹{item.price * item.qty}
            </p>
          </div>
        ))}
      </div>


      <div className="order-summary-footer">
        <span>Total</span>
        <span>₹{subtotal}</span>
      </div>
    </div>
  </div>
)}



          {/* ================= NOT LOGGED IN → OTP ================= */}


          {(!isAuth || !user?.mobileNumber) &&(

            <div className="check-booking-form-input-number-content">

              {/* ================= MOBILE SCREEN ================= */}
              {!otpSent && (
                <>
                  <p>Enter mobile number</p>
                  <p>Provide your mobile number to continue</p>

                  <div className="mobile-input-wrapper">
                    <span className="country-code">+91</span>
                    <input
                      type="tel"
                      maxLength="10"
                      placeholder="Enter 10 digit number"
                      value={mobile}
                      onChange={(e) => {
                        const value = e.target.value.replace(/\D/g, "");
                        setMobile(value);
                        setErrorSMS(null);
                      }}
                    />
                  </div>
                </>
              )}



              {/*================= OTP SCREEN ================= */}
              
              
              {otpSent && (
                <>
                  <p className="otp-heading">Verify OTP</p>
                  <p className="otp-sub-heading">
                    We’ve sent a 6-digit code to +91 {mobile}
                  </p>


              <div className="check-out-otp-container-box">
                  <input
                    type="text"
                    maxLength="6"
                    placeholder="Enter 6 digit OTP"
                    value={otp}
                    onChange={(e) => {
                      const value = e.target.value.replace(/\D/g, "");
                      setOtp(value);
                      setErrorSMS(null);
                    }}
                    className="otp-input-single"
                  />
                </div>
                </>
              )}


              {/* ================= LOADING ================= */}
              {loading && (
                <p className="info-text">
                  {otpSent ? "Verifying OTP..." : "Sending OTP..."}
                </p>
              )}


              {/* ================= ERROR ================= */}
              {errorSMS && <p className="error-text">{errorSMS}</p>}
            </div>

          )}


    {/* :::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::
    ::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::: */}

     

          {formError && (
                    <div className="form-error-message">
                      {formError}
                    </div>
                  )}



          {isAuth && user?.mobileNumber &&  (
            <div className="check-booking-address-form-section">
              <h4>Add shipping address</h4>

              <input
                type="text"
                placeholder="Pincode*"
                maxLength="6"
                value={pincode}
                className="pincode-number-input"
                onChange={(e) => handlePincode(e.target.value)}
              />

              {pinLoading && <p className="info-text">Checking pincode…</p>}
              {pinError && <p className="error-text">{pinError}</p>}

              <div className="row">
                <input
                  type="text"
                  placeholder="First name*"
                  value={firstName}

                  onChange={(e) => setFirstName(e.target.value)}
                  
              
              />
                <input
                  type="text"
                  placeholder="Last name*"
                  value={lastName}
                  onChange={(e) => setLastName(e.target.value)}
                />
              </div>

              <div className="row">
                <input
                  type="text"
                  placeholder="Flat, house no, building*"
                  value={address1}
                  onChange={(e) => setAddress1(e.target.value)}
                />

                <input
                  type="text"
                  placeholder="Area, street, sector*"
                  value={address2}
                  onChange={(e) => setAddress2(e.target.value)}
                />
              </div>

              <div className="row">
                <input value={city} disabled placeholder="City" />
                <input value={stateName} disabled placeholder="State" />
              </div>

              {/* ===== Address Type ===== */}



              <div className="address-type-section">
                <p className="address-type-label">Address type</p>

                <div className="address-type-options">
                  {["Home", "Office", "Others"].map((type) => (
                    <label key={type} className="address-type-option">
                      <input
                        type="radio"
                        name="addressType"
                        checked={addressType === type}
                        onChange={() => setAddressType(type)}
                      />
                      <span>{type}</span>
                    </label>
                  ))}
                </div>
              </div>



  



              <div className="check-booking-number-details-container">
                Contact Number:
               <span> {user?.mobileNumber ? user.mobileNumber : "Not found"} </span>
              </div>
            </div>




          )}

       



        </div>


         {isAuth && user?.mobileNumber &&  (

                <div className="check-booking-bottom-btn-main-container">
            <div className="check-out-booking-btn-content">

              <div
                className="book-online-btn"
                onClick={handleOnlineBooking}
              >
                Pay Now <span>(₹{totalPaybleAmmountOnline()})</span>
              </div>

              <div
                className="book-cash-btn"
                onClick={handleCashBooking}
              >
                Book on Cash <span>(₹{subtotal})</span>
              </div>

            </div>
          </div>


         )}

      </div>
    </div>
  );
}

export default CheckBookingForm;
